import isNull from "lodash/isNull";
import {
    Link,
    StepCSSTransitionGroup,
    Tabs
} from '@wg/wows-react-uikit'
import {
    BattleSelector,
    LadderSeasonsDropdown,
    NonOperationalEntries, OperationalEntries
} from 'fe2/Components/UIKit/UIKit'
import { ClanRec2SettingsIsEnabled, ClanRecSettingsIsEnabled } from 'helpers/common'
import { t } from 'helpers/localization'
import PropTypes from 'prop-types'
import React from 'react'
import { hasPermission, permissions, roleNames } from 'roles'
import dwhExport from '~/dwhExport'
import { BATTLE_TYPES } from '../../constants'
import { SEASON_TYPES } from 'reducers/ReducerClanBattles'
import { isClanBattleType } from "helpers/ladder";
import headersAccountApplications from './headers.account.settings.applications'
import headersAccountInvites from './headers.account.settings.invites'
import headersClanApplications from './headers.clan.settings.applications'
import headersClanInvites from './headers.clan.settings.invites'
import styles from './Requests.scss'

const propTypes = {
    battleTypes: PropTypes.array.isRequired,
    requestsBattleType: PropTypes.string.isRequired,
    currentAccount: PropTypes.shape({
        id: PropTypes.number.isRequired,
        clanId: PropTypes.number,
        roleName: PropTypes.oneOf(roleNames),
        inClanCooldownTill: PropTypes.string,
    }).isRequired,
    clan: PropTypes.shape({
        members_count: PropTypes.number.isRequired,
    }),

    isCurrentClanFull: PropTypes.bool,
    clanLoaded: PropTypes.bool.isRequired,
    root: PropTypes.string.isRequired,
    clanRulesContent: PropTypes.object.isRequired,
    currentRequestsTab: PropTypes.string.isRequired,

    invitesEntries: PropTypes.shape({
        sort: PropTypes.shape({
            order: PropTypes.string.isRequired,
            isAsc: PropTypes.bool.isRequired,
        }).isRequired,
        isFetching: PropTypes.bool.isRequired,
        page: PropTypes.number.isRequired,
        invites: PropTypes.arrayOf(PropTypes.object).isRequired,
        meta: PropTypes.object,
        error: PropTypes.object,
    }).isRequired,

    applicationsEntries: PropTypes.shape({
        sort: PropTypes.shape({
            order: PropTypes.string.isRequired,
            isAsc: PropTypes.bool.isRequired,
        }).isRequired,
        isFetching: PropTypes.bool.isRequired,
        page: PropTypes.number.isRequired,
        applications: PropTypes.arrayOf(PropTypes.object).isRequired,
        meta: PropTypes.object,
        error: PropTypes.object,
    }).isRequired,
    selectedApplicationsPlayersIds: PropTypes.array,

    onRender: PropTypes.func.isRequired,
    fetchEntriesByCurrentState: PropTypes.func.isRequired,
    onReloadClick: PropTypes.func.isRequired,
    onSendInvite: PropTypes.func,
    sendApplication: PropTypes.func,
    onBattleTypeChange: PropTypes.func.isRequired,

    onAcceptedEntryInvites: PropTypes.func,
    onDeclinedEntryInvites: PropTypes.func,
    onApplicationsPlayerTick: PropTypes.func,
    onAllApplicationsPlayersTick: PropTypes.func,
    onAcceptedEntryApplications: PropTypes.func,
    onDeclinedEntryApplication: PropTypes.func,
    onDeclineApplications: PropTypes.func,

    fetchEntriesByPageInvites: PropTypes.func.isRequired,
    fetchEntriesByPageApplications: PropTypes.func.isRequired,
    onSortClickInvites: PropTypes.func.isRequired,
    onSortClickApplications: PropTypes.func.isRequired,

    openAccountProfile: PropTypes.func,
    onRulesDialogClick: PropTypes.func,
    dropSelection: PropTypes.func,
    openChatWindow: PropTypes.func,
    onToggleTab: PropTypes.func,
    onOldRecommendationsClanSettingsClick: PropTypes.func,
    onRecommendationsClanSettingsClick: PropTypes.func,
}

class Requests extends React.Component {
    constructor() {
        super()

        this.onBattleTypeChange = this.onBattleTypeChange.bind(this)
        this.fetchEntriesByCurrentState = this.fetchEntriesByCurrentState.bind(this)
    }

    componentDidMount() {
        const currentAccount = this.props.currentAccount
        const canHandleInvites = hasPermission(currentAccount.roleName, permissions.HANDLE_INVITES)

        dwhExport.send('requests.open_page')
        if (this.props.currentRequestsTab === 'invites') {
            if (canHandleInvites) {
                dwhExport.send('requests.clan_requests.view_invites')
            } else {
                dwhExport.send('requests.player_requests.view_invites')
            }
        } else {
            if (canHandleInvites) {
                dwhExport.send('requests.clan_requests.view_requests')
            } else {
                dwhExport.send('requests.player_requests.view_requests')
            }
        }

        if (this.props.currentAccount.clanId && !this.props.clanLoaded) {
            this.props.onRender(this.props.currentAccount.clanId)
        }
    }

    fetchEntriesByCurrentState(withGlobalSpinner) {
        this.props.fetchEntriesByCurrentState(withGlobalSpinner, this.props.currentRequestsTab)
    }

    onBattleTypeChange(battleType) {
        this.props.onBattleTypeChange(battleType, this.props.currentRequestsTab)
    }

    renderRecommendationClanSettings() {
        if (!this.props.currentAccount.clanId) return null

        const hasPermissionChangeSettings = hasPermission(this.props.currentAccount.roleName, permissions.CHANGE_SETTINGS)
        const canSeeClanRecSettings = ClanRecSettingsIsEnabled && hasPermissionChangeSettings
        const canSeeClanRec2Settings = ClanRec2SettingsIsEnabled && hasPermissionChangeSettings

        const clanRecSettings = (
            canSeeClanRecSettings ? (
                <Link key="clanrec" isActionLink onClick={this.props.onOldRecommendationsClanSettingsClick}>
                    {t('Игровые предпочтения клана')}
                </Link>
            ) : null
        )

        const clanRec2Settings = (
            canSeeClanRec2Settings ? (
                <Link key="clanrec2" isActionLink onClick={() => {
                    this.props.onRecommendationsClanSettingsClick()
                }}>
                    {t('Изменить требования клана')}
                </Link>
            ) : null
        )

        return [clanRecSettings, clanRec2Settings]
    }

    renderSeasonsMenu() {
        if (isNull(this.props.requestsSeason)) return null;

        return <div className={styles.seasonsMenu}>
          <LadderSeasonsDropdown selectedSeasonId={this.props.requestsSeason} selectedSeasonType={this.props.requestsSeasonType} onSeasonChange={this.props.onSeasonChange} dropdownPosition="bottom" />
        </div>;
      }

    render() {
        const currentAccount = this.props.currentAccount
        let invites
        let applications
        let tabsData
        if (currentAccount.clanId) {
            tabsData = [
                { value: 'applications', content: t('Заявки от игроков') },
                { value: 'invites', content: t('Приглашения') },
            ]

            if (hasPermission(currentAccount.roleName, permissions.HANDLE_INVITES)) {
                invites = (
                    <NonOperationalEntries
                        entryType="invites"
                        headers={headersAccountInvites}
                        battleTypes={this.props.battleTypes}
                        currentAccount={this.props.currentAccount}
                        isCurrentClanFull={this.props.isCurrentClanFull}
                        root={this.props.root}
                        entries={this.props.invitesEntries}

                        fetchEntriesByCurrentState={this.fetchEntriesByCurrentState}
                        onBattleTypeChange={this.onBattleTypeChange}
                        onReloadClick={this.props.onReloadClick}
                        sendApplication={this.props.sendApplication}
                        onSendInvite={this.props.onSendInvite}

                        fetchEntriesByPage={this.props.fetchEntriesByPageInvites}
                        onSortClick={this.props.onSortClickInvites}

                        openAccountProfile={this.props.openAccountProfile}
                        openChatWindow={this.props.openChatWindow}
                    />
                )
            }
            if (this.props.clanLoaded && hasPermission(currentAccount.roleName, permissions.HANDLE_INVITES)) {
                applications = (
                    <OperationalEntries
                        entryType="applications"
                        headers={headersAccountApplications}
                        battleTypes={this.props.battleTypes}
                        currentAccount={this.props.currentAccount}
                        clan={this.props.clan}
                        entries={this.props.applicationsEntries}
                        clanRulesContent={this.props.clanRulesContent}
                        root={this.props.root}


                        selectedApplicationsPlayersIds={this.props.selectedApplicationsPlayersIds}
                        onApplicationsPlayerTick={this.props.onApplicationsPlayerTick}
                        onAllApplicationsPlayersTick={this.props.onAllApplicationsPlayersTick}

                        fetchEntriesByCurrentState={this.fetchEntriesByCurrentState}
                        onBattleTypeChange={this.onBattleTypeChange}
                        onReloadClick={this.props.onReloadClick}

                        fetchEntriesByPage={this.props.fetchEntriesByPageApplications}
                        onSortClick={this.props.onSortClickApplications}
                        onAcceptedEntry={this.props.onAcceptedEntryApplications}
                        onDeclinedEntry={this.props.onDeclinedEntryApplication}
                        onDeclineApplications={this.props.onDeclineApplications}

                        openAccountProfile={this.props.openAccountProfile}
                        openChatWindow={this.props.openChatWindow}
                        onRulesDialogClick={this.props.onRulesDialogClick}

                        dropSelection={this.props.dropSelection}
                    />
                )
            }
        } else {
            tabsData = [
                { value: 'invites', content: t('Приглашения от кланов') },
                { value: 'applications', content: t('Мои заявки') },
            ]

            invites = (
                <OperationalEntries
                    entryType="invites"
                    headers={headersClanInvites}
                    battleTypes={this.props.battleTypes}
                    currentAccount={this.props.currentAccount}
                    clan={this.props.clan}
                    entries={this.props.invitesEntries}
                    clanRulesContent={this.props.clanRulesContent}
                    root={this.props.root}

                    fetchEntriesByCurrentState={this.fetchEntriesByCurrentState}
                    onBattleTypeChange={this.onBattleTypeChange}
                    onReloadClick={this.props.onReloadClick}

                    fetchEntriesByPage={this.props.fetchEntriesByPageInvites}
                    onSortClick={this.props.onSortClickInvites}
                    onAcceptedEntry={this.props.onAcceptedEntryInvites}
                    onDeclinedEntry={this.props.onDeclinedEntryInvites}

                    openAccountProfile={this.props.openAccountProfile}
                    openChatWindow={this.props.openChatWindow}
                    onRulesDialogClick={this.props.onRulesDialogClick}
                    dropSelection={this.props.dropSelection}
                />
            )

            applications = (
                <NonOperationalEntries
                    entryType="applications"
                    headers={headersClanApplications}
                    battleTypes={this.props.battleTypes}
                    currentAccount={this.props.currentAccount}
                    isCurrentClanFull={this.props.isCurrentClanFull}
                    root={this.props.root}
                    entries={this.props.applicationsEntries}

                    fetchEntriesByCurrentState={this.fetchEntriesByCurrentState}
                    onBattleTypeChange={this.onBattleTypeChange}
                    onReloadClick={this.props.onReloadClick}
                    sendApplication={this.props.sendApplication}
                    onSendInvite={this.props.onSendInvite}

                    fetchEntriesByPage={this.props.fetchEntriesByPageApplications}
                    onSortClick={this.props.onSortClickApplications}

                    openAccountProfile={this.props.openAccountProfile}
                    openChatWindow={this.props.openChatWindow}
                />
            )
        }

        return (
            <div>
                <StepCSSTransitionGroup level={1}>
                    <div data-staff-name="requests_change-battle-type" className = {styles.battleSelectorWrap}>
                        <BattleSelector
                            key="battle-selector"
                            items={this.props.battleTypes}
                            selected={this.props.requestsBattleType}
                            onBattleTypeChange={this.onBattleTypeChange}
                        />
                    </div>
                    {isClanBattleType(this.props.requestsBattleType) ? this.renderSeasonsMenu() : null}
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={2}>
                    <div className={styles.tablesMenuWrap}>
                        <Tabs
                            tabs={tabsData}
                            tabSelected={this.props.currentRequestsTab}
                            onToggleTab={(value) => {
                                const currentAccount = this.props.currentAccount
                                const canHandleInvites = hasPermission(currentAccount.roleName, permissions.HANDLE_INVITES)
                                this.props.onToggleTab(value, canHandleInvites)
                            }}
                        />
                        {this.renderRecommendationClanSettings()}
                    </div>
                </StepCSSTransitionGroup>
                <StepCSSTransitionGroup level={3}>
                    {this.props.currentRequestsTab === 'invites' ? invites : applications}
                </StepCSSTransitionGroup>
            </div>
        )
    }
}

Requests.propTypes = propTypes

export default Requests